import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "timeUnit",
  standalone: false
})
export class TimeUnitPipe implements PipeTransform {
  readonly minuteLimit = 60;
  readonly hourLimit = 60;
  readonly dayLimit = 24;

  constructor(private translate: TranslateService) {}

  transform(seconds: number): string {
    if (seconds < this.minuteLimit) {
      const secondsLabel: string = this.translate.instant("timeUnitPipe.seconds", { time: seconds });
      return secondsLabel;
    }

    const minute = Math.floor(seconds / this.minuteLimit);
    const minuteRemainder = Math.floor(seconds % this.minuteLimit);

    if (minute < this.hourLimit) {
      const minuteLabel: string = this.translate.instant("timeUnitPipe.minutes", { time: minute });
      const secondsLabel: string = this.translate.instant("timeUnitPipe.seconds", { time: minuteRemainder });
      return `${minuteLabel} ${secondsLabel}`;
    }

    const hour = Math.floor(minute / this.hourLimit);
    const hourRemainder = Math.floor(minute % this.hourLimit);

    if (hour < this.dayLimit) {
      const hourLabel: string = this.translate.instant("timeUnitPipe.hours", { time: hour });
      const minuteLabel: string = this.translate.instant("timeUnitPipe.minutes", { time: hourRemainder });
      return `${hourLabel} ${minuteLabel}`;
    }

    const day = Math.floor(hour / this.dayLimit);
    const dayRemainder = Math.floor(hour % this.dayLimit);
    const dayLabel: string = this.translate.instant("timeUnitPipe.days", { time: day });
    const hourLabel: string = this.translate.instant("timeUnitPipe.hours", { time: dayRemainder });
    return `${dayLabel} ${hourLabel}`;
  }
}
